import { createRouter, createWebHistory } from 'vue-router';

const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
const Asn = () => import(/* webpackChunkName: "asn" */ '../views/Asn.vue')
const About = () => import(/* webpackChunkName: "about" */ '../views/About.vue')
const Contact = () => import(/* webpackChunkName: "route-contact" */ '../views/Contact.vue')
const Ipcheck = () => import(/* webpackChunkName: "ipcheck" */ '../views/Ipcheck.vue')
//const Test = () => import(/* webpackChunkName: "test" */ '../views/Test.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Ipcheck,
    meta: {
      title: 'Instrument de detectare IP - Detectarea adreselor IP interne și străine',
      subtitle: 'Instrument online gratuit de detectare a IP',
      description: 'Utilizați instrumentul nostru online gratuit pentru a vă detecta rapid adresa IP și pentru a determina dacă este un IP național sau străin.'
    },
  },
  {
    path: '/ip-check',
    name: 'IPCheck',
    component: Ipcheck,
    meta: {
      title: 'Detectarea adresei IP - Instrumente de identificare IP interne și străine',
      subtitle: 'Detectarea adresei IP online',
      description: 'Detectează-ți adresa IP rapid și precis pentru a ști dacă IP-ul tău este din țară sau din străinătate.'
    },
  },
  {
    path: '/ip-information',
    name: 'IP',
    component: Home,
    meta: {
      title: 'Interogare de informații IP - informații detaliate despre adresa IP',
      subtitle: 'Interogare de informații detaliate despre adresa IP',
      description: 'Obțineți detalii despre adresa dvs. IP, inclusiv localizarea geografică, ISP și multe altele.'
    },
  },
  {
    path: '/asn-lookup',
    name: 'ASN',
    component: Asn,
    meta: {
      title: 'Instrument de interogare ASN – Detectare IP ASN',
      subtitle: 'Interogare cu numărul ASN',
      description: 'Utilizați instrumentul nostru de căutare ASN pentru a găsi rapid numărul de sistem autonom (ASN) corespunzător unei adrese IP.'
    },
  },
  {
    path: '/despre-noi',
    name: 'About',
    component: About,
    meta: {
      title: 'Despre noi - Echipa IP Detection Tool',
      subtitle: 'Faceți cunoștință cu echipa noastră',
      description: 'Aflați despre antecedentele, misiunea echipei noastre și de ce ne angajăm să oferim cele mai bune instrumente de detectare a IP.'
    },
  },
  //{
    //path: '/test',
    //name: 'Test',
    //component: Test,
    //meta: {
      //title: 'Test - test',
      //subtitle: 'Simple test',
      //description: 'Test test.'
    //},

  {
    path: '/contact',
    name: 'Contact',
	component: Contact,
    meta: {
      title: 'Contactați-ne - obțineți asistență și feedback',
      subtitle: 'Contactați echipa noastră',
      description: 'Aveți întrebări sau sugestii? Contactați echipa noastră, suntem aici pentru a vă ajuta.'
    },
    //component: () => import(/* webpackChunkName: "route-contact" */ '../views/Contact.vue')
  },
  
  {
    path: '/api-documentare',
    name: 'Docs',
    meta: {
      title: 'Documentație API - Ghid de utilizare a interfeței instrumentului de detectare IP',
      subtitle: 'Documentația de utilizare a API',
      description: 'Consultați documentația noastră API pentru a afla cum să integrați funcționalitatea de detectare IP în aplicația dvs.'
    },
    component: () => import(/* webpackChunkName: "route-docs" */ '../views/Docs.vue')
  },
  {
  path: '/:pathMatch(.*)*',
  name: 'NotFoundPage',
  //component: 'NotFoundPage',
      meta: {
      title: '404',
      subtitle: 'pagina nu a fost găsit',
      description: 'Se pare că ești pe pagina greșită.'
    },
    component: () => import(/* webpackChunkName: "route-notfoundpage" */ '../views/NotFoundPage.vue')
  },
  
    {
  path: '/privacy-policy',
  name: 'Privacy-Policy',
  //component: 'privacy-policy',
      meta: {
      title: 'Politica de confidențialitate.',
      subtitle: 'Politica de confidențialitate.',
      description: 'Politica de confidențialitate.'
    },
    component: () => import(/* webpackChunkName: "route-privacy-policy" */ '../views/Privacy-Policy.vue')
  },
  
      {
  path: '/terms-of-service',
  name: 'Terms-Of-Service',
  //component: 'privacy-policy',
      meta: {
      title: 'Termeni și condiții',
      subtitle: 'Termeni și condiții',
      description: 'Termeni și condiții'
    },
    component: () => import(/* webpackChunkName: "route-terms-of-service" */ '../views/Terms-Of-Service.vue')
  },

]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const title = to.meta.title || 'Instrument de căutare a adresei IP'
  const subtitle = to.meta.subtitle || ''
  const description = to.meta.description || 'Instrument gratuit de căutare a adresei IP. Obțineți informații detaliate despre orice adresă IP, inclusiv locație, ISP și multe altele.'
  document.title = subtitle ? `${title} - ${subtitle}` : title

  // Update meta tags
  updateMetaTag('description', description)
  updateMetaTag('og:title', title)
  updateMetaTag('og:description', description)
  updateMetaTag('twitter:title', title)
  updateMetaTag('twitter:description', description)

  next()
})

function updateMetaTag(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = name
    document.head.appendChild(meta)
  }
  meta.content = content
}

export default router
